import { createStore } from 'satcheljs';
export default createStore('forwardingOption', {
    choiceGroupSelection: null,
    forwardingEmailAddress: null,
    keepCopy: null,
})();
//# sourceMappingURL=store.js.map